import React, { HTMLAttributes } from 'react';
import classnames from 'classnames';

export const HeaderVerticalDivider = ({ className, ...other }: HeaderVerticalDividerProps) => (
  <div
    className={classnames('h-4 w-px bg-gray-200', className)}
    role="presentation"
    {...other}
  />
);

export type HeaderVerticalDividerProps = HTMLAttributes<HTMLDivElement>;
